import React from 'react';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';
import CardDeck from 'react-bootstrap/CardDeck';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { forwardToWithParams, forwardTo } from "../../../../helpers";
import './MenuMelillaPage.css';
import { EntitySearch, DynamicBackground } from '../../../../components'
import { isWebpSupported } from 'react-image-webp/dist/utils';
import "react-multi-carousel/lib/styles.css";

class MenuMelillaPage extends React.Component {
  //CARGAR AYUNTAMIENTO POR PARAMETRO AO
  constructor(props) {
    super(props);

    this.state = {
      aytoName: '',
      ao: { ao: 10453 },
    };
    this.handleSelectedEntity = this.handleSelectedEntity.bind(this);
  }

  handleSelectedEntity(entity) {
    this.setState({ aytoName: entity.Nombre });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleDeleteUser(id) {
    //return (e) => this.props.dispatch(userActions.delete(id));
  }

  render() {
    const { ao } = this.state;
    
    return (
      <DynamicBackground customOverlay="rgba(0, 0, 0, 0.5)" background={isWebpSupported() ? "https://gecorcloud.com/images/onil.webp" : "https://gecorcloud.com/images/onil.jpg"}>

      <div className='enviromental-website-home'>   

        <div className='info-enviromental'>    
        <div className='info-enviromental-title'>
                    <p>MEDIO AMBIENTE</p>
                  </div>
          <CardDeck>
            <Card>
              <Card.Img variant="top" src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/informacion_local_ambiental.jpg" />
              <Card.Body>
                <Card.Title>Información local ambiental</Card.Title>
                <hr></hr>
                <Card.Text>
                  Información ambiental del Ayuntamiento de Melilla a rápida disposición del ciudadano.
                </Card.Text>
                <Button variant="outline-success" onClick={() => forwardTo('/local-information-page-Melilla')}>Saber más</Button>
              </Card.Body>
            </Card>
            <Card>
              <Card.Img variant="top" src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/especies_ambientales.jpg" />
              <Card.Body>
                <Card.Title>Especies Ambientales</Card.Title>
                <hr></hr>
                <Card.Text>
                Información general sobre Especies ambientales en España y documentación relevante para la conservación de especies.
                </Card.Text>
                <Button variant="outline-success" onClick={() => forwardTo('/enviromental-information-Melilla')}>Saber más</Button>
              </Card.Body>
            </Card>
            <Card>
              <Card.Img variant="top" src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/educacion_ambiental2.jpg" />
              <Card.Body>
                <Card.Title>Educación Ambiental</Card.Title>
                <hr></hr>
                <Card.Text>
                Documentación medioambiental de importancia para el amprendizaje para un futuro sostenible.
                </Card.Text>
                <Button variant="outline-success" onClick={() => forwardTo('/educacion-ambiental-Melilla')}>Saber más</Button>
              </Card.Body>
            </Card>
          </CardDeck>


          <CardDeck>
            <Card>
              <Card.Img variant="top" src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/glosario_ambiental.jpg" />
              <Card.Body>
                <Card.Title>Glosario Ambiental</Card.Title>
                <hr></hr>
                <Card.Text>
                Glosario que contiene palabras, definiciones e imagenes descriptivas de palabras relacionadas con medio ambiente.
                </Card.Text>
                <Button variant="outline-success" onClick={() => window.open('https://gecorcloud.com/pdf/Glosario-ambiental-GECOR.pdf')}>Saber más</Button>
              </Card.Body>
            </Card>
            <Card>
              <Card.Img variant="top" src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/practicas_sobre_medio_ambiente.jpg" />
              <Card.Body>
                <Card.Title>Prácticas Sobre Medio Ambiente</Card.Title>
                <hr></hr>
                <Card.Text>
                Prácticas del día a día para mejorar nuestro mundo y sostenibilidad medioambiental.
                </Card.Text>
                <Button variant="outline-success" onClick={() => forwardTo('/CitizenGuidePage-Melilla')}>Saber más</Button>
              </Card.Body>
            </Card>
            <Card>
              <Card.Img variant="top" src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/enlaces_interes.jpg" />
              <Card.Body>
                <Card.Title>Enlaces de Interés</Card.Title>
                <hr></hr>
                <Card.Text>
                Directorio de enlaces de interés en relación con el Medio Ambiente.
                </Card.Text>
                <Button variant="outline-success" onClick={() => window.open('https://gecorcloud.com/pdf/enlaces.pdf', '_blank')}>Saber más</Button>
              </Card.Body>
            </Card>
          </CardDeck>
        </div>

        <div className='download-enviromental'>

            <div className='download-enviromental-title'>
              <p>CONSULTAS MEDIOAMBIENTALES</p>
            </div>
            <CardDeck>
              <Card>
              <Card.Body>
                <div className='message-ico-enviromental'>
                  <img className='message-ico-png' src="https://cdn-icons-png.flaticon.com/512/520/520648.png"></img>
                  <div class="text-decor"></div>
                </div>
                <Card.Text>
                Aquí puedes realizar cualquier tipo de consulta medioambiental. Responderemos lo más pronto posible.
                </Card.Text>
                <Button variant="outline-success" onClick={() => forwardTo('/contacto-medioambiente-Melilla')}>Realizar consulta</Button>
              </Card.Body>
            </Card>
            </CardDeck>
        </div>

        <div className='incident-enviromental'>
            <Container className='container-incident-enviromanetal'>
              <Row>
                <Col sm={6}>
                  <div className='info-enviromental-title'>
                    <p>Comunicar incidencias</p>
                  </div>
                  <div className='incident-txt'>
                    <p>Para realizar cualquier tipo de incidencia en la vía urbana en el Ayuntamiento de Melilla, basta con hacerla a través de la App de GECOR.</p>
                    <p>Descarga la App, selecciona tu ayuntamiento, y comienza a hacer incidencias. Es muy sencillo, sólo necesitas seleccionar el tipo de incidencia, aportar una imagen y la ubicación.</p>
                    <p>También tenemos disponible un gestor de incidencias web, para los que no puedan descargar la APP:</p>
                    <Button variant="outline-success" onClick={() => window.open('https://gecorweb.com/login?ao=10453')}>Gestor de incidencias web</Button>
                  </div>

                  </Col>
                <Col sm={4}>
                <div className='download-enviromental-stores'>
                <div className='info-enviromental-title'>
                    <p>Menú ambiental</p>
                    <div class="text-decor"></div>
                  </div>
                </div>
                <Row className="row-incident">
                          <Col sm={6}>
                            <img tabIndex="12" src="https://gecorcloud.com/images/QRApple.jpg" className="qr-app-store" alt="qr-app-store" />
                            <br></br>
                            <a tabIndex="13" target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/es/app/melilla-contigo/id6744894730">
                              <img src="https://gecorcloud.com/images/app-store-ico.png" alt="app-store" className="download-store-btn-ln" />
                            </a>
                          </Col>
                          <Col sm={6}>
                            <img tabIndex="14" src="https://gecorcloud.com/images/QRAndroid.jpg" className="qr-google-play" alt="qr-google-play" />
                            <br></br>
                            <a tabIndex="15" target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=melilla.gecorsystem.gecorn&hl=es">
                              <img src="https://gecorcloud.com/images/google-play-ico.png" className="download-store-btn-ln" alt="google-play" />
                            </a>
                          </Col>
                        </Row>

                </Col>
              </Row>
            </Container>
        </div>
      </div>
      <EntitySearch className="ayto-borde" redirect={false} onSelected={this.handleSelectedEntity} ao={ao} hide={true} />


    </DynamicBackground>
    );
  }
}

const mapStateToProps = (state) => {
  const { users } = state;
  const { user } = users;
  return {
    user
  };
}

const connectedMenuMelillaPage = connect(mapStateToProps)(MenuMelillaPage);
export { connectedMenuMelillaPage as MenuMelillaPage };